import { GeneralSettingsPage } from '@/pages/settings';
import { ModeProvider } from '@/providers/ModeProvider';

export function Step3GeneralSettings() {
  return (
    <div className="flex flex-col h-full">
      {/* Step header */}
      <div className="mb-5 shrink-0">
        <h2 className="text-xl font-semibold mb-1">General Settings</h2>
        <p className="text-sm text-muted-foreground">
          Configure your metrics, ageing analysis bands and customer settings.
          You can leave everything as the default or customise it now — you can always come back later.
        </p>
      </div>

      {/* Embedded General Settings */}
      <div className="flex-1 min-h-0 overflow-auto rounded-xl border bg-background">
        <div className="p-1">
          <ModeProvider>
            <GeneralSettingsPage />
          </ModeProvider>
        </div>
      </div>
    </div>
  );
}
